export const TAB_ID_PARAM = 'tabId';
export const YAV_LINK = 'https://yav.yandex-team.ru/';
